module.exports = __webpack_public_path__ + "static/media/tractorPlow_salmon.40ee6835.svg";